import React, { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import NavigationBar from "component/navigationBar/NavigationBar";
import NavigationBarItemBack from "component/navigationBar/NavigationBarItemBack";
import NavigationBarItem from "component/navigationBar/NavigationBarItem";
import NavigationBarTabs from "component/navigationBar/NavigationBarTabs";
import t from "module/translations";

interface Props {
  listPath: string;
  overviewPath: string;
  objectivesPath: string;
}

const AssessmentDetailsNavigation: React.FC<Props> = ({
  listPath,
  overviewPath,
  objectivesPath,
}) => {
  const matchedOverview = Boolean(
    useRouteMatch({
      path: overviewPath,
      exact: true,
    })
  );
  const matchedObjectives = Boolean(
    useRouteMatch({
      path: objectivesPath,
      exact: true,
    })
  );

  const matchedList = false;

  const tabMap: boolean[] = useMemo(
    () => [matchedList, matchedOverview, matchedObjectives],
    [matchedList, matchedObjectives, matchedOverview]
  );

  return (
    <NavigationBar>
      <NavigationBarTabs {...{ tabMap }}>
        <NavigationBarItemBack
          {...{
            path: listPath,
            key: listPath,
          }}
        />
        <NavigationBarItem
          {...{
            key: overviewPath,
            path: overviewPath,
            title: t.competencyManagement.assessment.overviewTitleText,
          }}
        />
        <NavigationBarItem
          {...{
            key: objectivesPath,
            path: objectivesPath,
            title: t.competencyManagement.assessment.objectivesTitleText,
          }}
        />
      </NavigationBarTabs>
    </NavigationBar>
  );
};

export default React.memo(AssessmentDetailsNavigation);
